import React from 'react';

export function NexusFilters({ children, className = '' }) {
  return <div className={`filters-bar ${className}`.trim()}>{children}</div>;
}

export function FilterGroup({ label, children }) {
  return (
    <div className="filter-group">
      {label ? <span className="filter-label">{label}</span> : null}
      {children}
    </div>
  );
}

export function SearchBar(props) {
  return <input className={`search-bar ${props.className || ''}`.trim()} {...props} />;
}
